// Nosh Produce — injects "Order on Grab" / "Get trade supply" buttons on
// product pages, where Add to cart used to be. Pairs with
// nosh-remove-checkout.css, which hides the original purchase UI.
// Text, link, and color are all editable in the Theme Editor (Product
// information section settings — "Nosh — buy buttons"), read here from
// data-nosh-* attributes on .product__info-container (see
// sections/main-product.liquid), so no code change is needed to update them.
// "Get trade supply" falls back to the Trade page (window.NOSH_PAGE_URLS, set
// by snippets/nosh-page-links.liquid) when no explicit link is set.
(function () {
  function injectBuyCtas() {
    var form = document.querySelector(".product-form");
    if (!form) return;
    // Re-run safely after a Theme Editor section reload: query from the
    // form's own parent, not the whole document, so a stale/removed
    // .nosh-buy-ctas from a previous render of THIS section doesn't block
    // re-injection, but a copy on some other section elsewhere on the page
    // still does.
    if (form.parentElement.querySelector(".nosh-buy-ctas")) return;

    var infoContainer = form.closest(".product__info-container");
    var data = (infoContainer && infoContainer.dataset) || {};
    var grabLabel = data.noshGrabLabel || "Order on Grab";
    var tradeLabel = data.noshTradeLabel || "Get trade supply";
    var grabUrl = data.noshGrabUrl || "https://r.grab.com/o/YR7bEr2y";
    var tradeUrl = data.noshTradeUrl || (window.NOSH_PAGE_URLS && window.NOSH_PAGE_URLS["get-started"]);

    var wrap = document.createElement("div");
    wrap.className = "nosh-buy-ctas";

    var grabLink = document.createElement("a");
    grabLink.href = grabUrl;
    grabLink.target = "_blank";
    grabLink.rel = "noopener";
    grabLink.className = "button button--primary";
    grabLink.textContent = grabLabel;
    if (data.noshGrabBg) grabLink.style.backgroundColor = data.noshGrabBg;
    if (data.noshGrabText) grabLink.style.color = data.noshGrabText;

    var tradeLink = document.createElement("a");
    tradeLink.className = "button button--secondary nosh-buy-ctas__trade";
    if (tradeUrl) tradeLink.href = tradeUrl;
    tradeLink.textContent = tradeLabel;
    if (data.noshTradeBg) tradeLink.style.backgroundColor = data.noshTradeBg;
    if (data.noshTradeText) tradeLink.style.color = data.noshTradeText;

    // GA4 tracking. Calls gtag() directly (confirmed present sitewide via
    // Shopify's Google channel) so the event reaches GA4 immediately with no
    // extra Tag Manager trigger to configure — a bare dataLayer.push only
    // becomes a real GA4 event if something is already listening for that
    // specific custom event name, which isn't guaranteed here. Also still
    // pushes to dataLayer for anyone who later wants to catch it in GTM.
    // Fires on the real click, before the link navigates away (grabLink
    // opens a new tab so there's no race; tradeLink navigates this tab, but
    // gtag()/dataLayer.push are synchronous so the event is queued before
    // the browser unloads the page).
    var variantSelects = form.closest(".product__info-container").querySelector("variant-selects");
    var productHandle = (variantSelects && variantSelects.dataset.productHandle) || null;

    function trackCtaClick(ctaName) {
      if (typeof window.gtag === "function") {
        window.gtag("event", "cta_click", { cta_name: ctaName, product_handle: productHandle });
      }
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ event: "cta_click", cta_name: ctaName, product_handle: productHandle });
    }
    grabLink.addEventListener("click", function () { trackCtaClick("order_on_grab"); });
    tradeLink.addEventListener("click", function () { trackCtaClick("get_trade_supply"); });

    wrap.appendChild(grabLink);
    wrap.appendChild(tradeLink);

    form.insertAdjacentElement("afterend", wrap);
  }

  document.addEventListener("DOMContentLoaded", injectBuyCtas);

  // The Theme Editor preview replaces a whole section's HTML (including our
  // injected buttons) via AJAX every time a block/setting is toggled there —
  // e.g. hiding the description block — which looked like hiding the
  // description was also hiding the buttons. DOMContentLoaded only fires
  // once, so without this the buttons never come back after that reload.
  // Real customers on the live storefront never trigger this event.
  document.addEventListener("shopify:section:load", injectBuyCtas);
})();
